import { render, staticRenderFns } from "./overviewList.vue?vue&type=template&id=215cf544"
import script from "./overviewList.vue?vue&type=script&lang=js"
export * from "./overviewList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports